import { Configuration } from "../../api-models";
import { InternalServerError, NotFoundError } from "../../api-models/errors";
import { ApplicationId, ProjectId, SubscriptionEnvironment } from "../../identifiers";
import { Store } from "../../store";
import { HttpApiEndpoint, HttpApiGroup, OpenApi } from "@effect/platform";
import { NotFound } from "@effect/platform/HttpApiError";
import { Schema } from "effect";
export const ConfigurationApi = HttpApiGroup.make("configuration").add(HttpApiEndpoint.post("sealString", "/seal").addSuccess(Schema.Struct({
    sealed: Schema.String
})).setPayload(Schema.Struct({
    unsealed: Schema.String
})).addError(NotFound)).add(HttpApiEndpoint.get("getConfigurationStatus", "/projects/:projectId/:store/configuration/status").setPath(Schema.Struct({
    store: Store.Schema,
    projectId: ProjectId.FromString
})).addSuccess(Configuration.Status).addError(InternalServerError).addError(NotFoundError).annotate(OpenApi.Summary, "GetConfigurationStatus")).add(HttpApiEndpoint.post("updateConfiguration", "/projects/:projectId/:store/:storeEnvironment/configuration").setPath(Schema.Struct({
    store: Store.Schema,
    storeEnvironment: SubscriptionEnvironment.Schema,
    projectId: ProjectId.FromString
})).setPayload(Schema.Struct({
    keys: Schema.Record({
        key: Schema.String,
        value: Schema.NullishOr(Schema.String)
    })
})).addError(InternalServerError).addSuccess(Schema.Struct({
    valid: Schema.Boolean
}))).add(HttpApiEndpoint.post("initiatePaddleOAuth", "/projects/:projectId/paddle/:environment/oauth/initiate").setPath(Schema.Struct({
    projectId: ProjectId.FromString,
    environment: SubscriptionEnvironment.Schema
})).addSuccess(Schema.Struct({
    authUrl: Schema.String,
    state: Schema.String
})).addError(InternalServerError).annotate(OpenApi.Summary, "Initiate Paddle OAuth flow")).add(HttpApiEndpoint.post("paddleOAuthCallback", "/paddle/oauth/callback").setPayload(Schema.Struct({
    code: Schema.String,
    state: Schema.String
})).addSuccess(Schema.Struct({
    success: Schema.Boolean,
    applicationId: ApplicationId.Schema
})).addError(NotFound).addError(InternalServerError).annotate(OpenApi.Summary, "Handle Paddle OAuth callback")).add(HttpApiEndpoint.patch("updatePaddleHostedCheckoutUrl", "/projects/:projectId/paddle/:environment/hosted-checkout-url").setPath(Schema.Struct({
    projectId: ProjectId.FromString,
    environment: SubscriptionEnvironment.Schema
})).setPayload(Schema.Struct({
    hostedCheckoutUrl: Schema.NullOr(Schema.String)
})).addSuccess(Schema.Struct({
    success: Schema.Boolean
})).addError(NotFound).addError(InternalServerError).annotate(OpenApi.Summary, "Update Paddle hosted checkout URL")).add(HttpApiEndpoint.post("refreshPaddleToken", "/projects/:projectId/paddle/:environment/oauth/refresh").setPath(Schema.Struct({
    projectId: ProjectId.FromString,
    environment: SubscriptionEnvironment.Schema
})).addSuccess(Schema.Struct({
    success: Schema.Boolean
})).addError(InternalServerError).annotate(OpenApi.Summary, "Refresh Paddle OAuth token")).add(HttpApiEndpoint.del("disconnectPaddleOAuth", "/projects/:projectId/paddle/:environment/oauth/disconnect").setPath(Schema.Struct({
    projectId: ProjectId.FromString,
    environment: SubscriptionEnvironment.Schema
})).addSuccess(Schema.Struct({
    success: Schema.Boolean
})).addError(InternalServerError).annotate(OpenApi.Summary, "Disconnect Paddle OAuth integration"));
